import { uiText } from '../../i18n/uiText';
import React, { useState } from 'react';
import { Copy, Mail, RotateCcw } from 'lucide-react';
import { getApiErrorMessage, outgoingEmailsApi } from '../../api';

export default function ProvisionedAccessCard({ access, onClose }) {
  const [copied, setCopied] = useState(false);
  const [resending, setResending] = useState(false);
  const [resendResult, setResendResult] = useState('');
  if (!access?.username || !access?.temporary_password) return null;
  const smtpMissing = access.status === 'smtp_not_configured';
  const copyAccess = async () => {
    const value = uiText("Логин: {v0}\nВременный пароль: {v1}", {v0: (access.username), v1: (access.temporary_password)});
    try {
      if (navigator.clipboard?.writeText && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (!successful) throw new Error('copy_failed');
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };
  const resend = async () => {
    if (!access.email_id || resending) return;
    setResending(true);
    setResendResult('');
    try {
      await outgoingEmailsApi.resend(access.email_id);
      setResendResult(uiText("Повторная отправка запущена автоматически. От вас дополнительных действий не требуется."));
    } catch (error) {
      setResendResult(getApiErrorMessage(error) || uiText("Не удалось повторить отправку."));
    } finally {
      setResending(false);
    }
  };
  return (
    <div className={`company-access-card ${smtpMissing ? 'is-warning' : 'is-success'}`}>
      <div className="company-access-card-icon"><Mail size={18} /></div>
      <div className="company-access-card-main">
        <b>{smtpMissing ? uiText("Доступ создан — настройте отправку почты") : uiText("Доступ создан, письмо отправляется автоматически")}</b>
        <p>
          {smtpMissing
            ? uiText("SMTP пока не настроен. Сохраните данные сейчас и передайте пользователю безопасным способом.")
            : uiText("Письмо отправляется на {v0}. От вас дополнительных действий не требуется. Данные ниже показываются только один раз.", {v0: (access.to_email)})}
        </p>
        <div className="company-access-credentials">
          <span><small>{uiText("Логин")}</small><strong>{access.username}</strong></span>
          <span><small>{uiText("Временный пароль")}</small><strong>{access.temporary_password}</strong></span>
          <button type="button" className="btn btn-outline btn-sm" onClick={copyAccess}><Copy size={14} /> {copied ? uiText("Скопировано") : uiText("Скопировать")}</button>
          {access.email_id ? <button type="button" className="btn btn-outline btn-sm" onClick={resend} disabled={resending}><RotateCcw size={14} /> {resending ? uiText("Отправляем…") : uiText("Отправить повторно")}</button> : null}
        </div>
        {resendResult ? <div className="company-access-resend-result" role="status">{resendResult}</div> : null}
      </div>
      {onClose && <button type="button" className="btn btn-ghost btn-sm" onClick={onClose} aria-label={uiText("Закрыть")}>✕</button>}
    </div>
  );
}
